import { render, staticRenderFns } from "./OidcGroups.vue?vue&type=template&id=92123204&"
import script from "./OidcGroups.vue?vue&type=script&lang=js&"
export * from "./OidcGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92123204')) {
      api.createRecord('92123204', component.options)
    } else {
      api.reload('92123204', component.options)
    }
    module.hot.accept("./OidcGroups.vue?vue&type=template&id=92123204&", function () {
      api.rerender('92123204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/accessmanagement/OidcGroups.vue"
export default component.exports